import { Component, Input } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyInactividadCotizador } from 'src/app/interfaces/body_inactividad_cotizador';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';

@Component({
  selector: 'app-fin-flujo-no',
  standalone: false,
  templateUrl: './fin-flujo-no.component.html',
  styleUrl: './fin-flujo-no.component.scss'
})
export class FinFlujoNoComponent {
  sessionId: string = '';

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';
  parametro: string = '';
  leadId: string = '';
  @Input() identLead!: string;
  codAsesor: string = '';
  IdBitacora: string = '';

  dataEnvioCotizador: BodyInactividadCotizador = {
    SessionId: '',
    productFamily: '',
    screenPercentage: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    isInactivity: false,
    leadRequeriment: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      },
      Property: {
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: '',
        DepartmentCode: '',
        CityProperty: '',
        Code: '',
        CityCode: ''
      }
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) {

  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);
        }
      }
    });
  }

  volverInicio(): void {
    this.GuardarDataLayer();
    window.location.href = "https://www.sura.co/";
  }

  private GuardarDataLayer() {
    this.dataEnvioCotizador.SessionId = this.sessionId;
    this.dataEnvioCotizador.productFamily = "Arrendamientos";
    this.dataEnvioCotizador.screenPercentage = '30'
    this.dataEnvioCotizador.leadId = this.leadId == 'undefined' ? "" : this.leadId;
    this.dataEnvioCotizador.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }
    else {
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }

    this.dataEnvioCotizador.isInactivity = false;
    this.dataEnvioCotizador.leadRequeriment = 'Fin de flujo sin inquilino';
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.dataEnvioCotizador.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataEnvioCotizador.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataEnvioCotizador.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.dataEnvioCotizador.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.dataEnvioCotizador.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.dataEnvioCotizador.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.dataEnvioCotizador.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.dataEnvioCotizador.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;



    this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvioCotizador).
      subscribe(
        (data) => {
          const response = data;
        }
      );
  }
}
